import React from "react";
import InfoBox from '../components/info.js'
import ImageBas from './../../images/BP_GH2.jpg'
import Panoramic from "../components/panoramic.js";

export default () => (
    <Panoramic>
        <div className='metadata--wrapper'>
            <img src={ImageBas} alt="" />
            <InfoBox>View of the city of Quebec taken from the North Side of the St. Charles (ca 1790). Gravure de J.C. Stadler, Travels Through the Canadas, 1807.</InfoBox>
        </div>
    </Panoramic>
);



// WEBPACK FOOTER //
// ./src/components/image-footer-une-ville-fabulee.js